import { Component, inject, signal, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthService } from '@core/services/auth.service';

import { LogoutDialogComponent } from '../../../features/auth/components/logout-dialog/logout-dialog.component';

@Component({
  selector: 'app-header',
  imports: [RouterLink, LogoutDialogComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  /** Read directly in the template: the header re-renders as the session changes. */
  readonly auth = inject(AuthService);
  private readonly logoutDialog = viewChild.required(LogoutDialogComponent);

  /**
   * In-page sections of the landing page. Routed rather than plain "#id"
   * hrefs so they also work from the other pages that show this header
   * (booking): the router goes home first, then scrolls to the fragment.
   * Each id must exist in home.component.html.
   */
  readonly navLinks = [
    { label: 'Services', fragment: 'services' },
    { label: 'Event Highlights', fragment: 'events' },
    { label: 'Our Plans', fragment: 'plans' },
    // TODO(design): there is no About Us section on the page yet, so this
    // lands on the footer blurb — the only "about the club" copy that exists.
    // Point it at the section once that is built.
    { label: 'About Us', fragment: 'about-us' },
    { label: 'Contact Us', fragment: 'contact-us' }
  ];

  readonly menuOpen = signal(false);

  toggleMenu(): void {
    this.menuOpen.update(open => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  /** Asks first; the dialog does the signing out (API + local session). */
  logout(): void {
    this.closeMenu();
    this.logoutDialog().open();
  }
}
